
import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(private http: HttpClient) { }

  /*
    EXAMPLE URL: https://ecataloguestg-api.cwsfirabarcelona.com/v1/products/38720?projection=detail&language=es_ES
  */
  getProductsDetails(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.GET_PRODUCTS_DETAILS + '/' + dataIn.productId + '?projection=' + dataIn.projectionType;

    return this.http.get(url, dataIn);
  }

  /*
    EXAMPLE URL: https://ecataloguestg-api.cwsfirabarcelona.com/v1/products/38720/images?projection=minimal&language=es_ES
  */
  getProductsImages(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.GET_PRODUCTS_IMAGES + '/' + dataIn.productId + '/images?projection=' + dataIn.projectionType;

    return this.http.get(url, dataIn);
  }

  /*
    EXAMPLE URL: https://ecataloguestg-api.cwsfirabarcelona.com/v1/products/38720/categories?language=es_ES
  */
  getProductsCategories(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.GET_PRODUCTS_CATEGORIES + '/' + dataIn.productId + '/categories';

    return this.http.get(url, dataIn);
  }

  /*
    EXAMPLE URL: https://ecataloguestg-api.cwsfirabarcelona.com/v1/catalogues/96/products/38720/hierarchicalProperties?language=es_ES
  */
  getHierarchicalProperties(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.GET_HIERARCHICAL_PROPERTIES + '/' + dataIn.catalogueId + '/products/' + dataIn.exhibitorId + '/hierarchicalProperties';
    
    return this.http.get(url, dataIn);
  }

  getProduct(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.GET_PRODUCTS_DETAILS + '/' + dataIn.productId;

    return this.http.get(url, dataIn);
  }

  saveProduct(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.SAVE_PRODUCT;

    if (dataIn.id) {
      return this.http.put(url, dataIn);
    } else {
      return this.http.post(url, dataIn);
    }

  }

  saveProducts(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.UPDATE_PRODUCTS;

      return this.http.post(url, dataIn);
  }

  updatePublished(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.UPDATE_PUBLISHED;

    return this.http.put(url, dataIn);

  }

  updateNovelties(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.UPDATE_NOVELTIES;

    return this.http.put(url, dataIn);

  }

  removeProduct(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.REMOVE_PRODUCT + '/' + dataIn.productId;

    return this.http.delete(url);

  }

    getCategories(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.PRODUCTS.GET_CATEGORIES + '/' + dataIn.productId + '/' + 'categories';

    return this.http.get(url, dataIn);
  }





}
